<template lang="pug">
    .video-editor-trim-control
        video-player-control(v-bind="videoPlayerAttrs" @ready="playerReady" ref="player")
        p.video-editor-trim-control__label Trim Video
        re-video-frame-range-slider(v-model="trimData" v-bind="trimmerAttrs")
</template>

<script>
/*global _ */
import {round, floor} from 'utils/vue/lib/formatters'
import ReVideoFrameRangeSlider from './re-video-frame-range-slider'
const {min} = Math
const components = {ReVideoFrameRangeSlider}

export default {
    name: 'video-editor-trim-control',
    components,
    props: {
        value: {
            default: null,
        },
        isActive: {
            type: [Boolean]
        },
        video: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            initValue: null,
            innerValue: this.value || null,
            videoMeta: this.video?.meta || {},
            duration: null,
            trimData: {
                start: 0,
                end: 0
            },
            player: null
        }
    },
    computed: {
        trimmerAttrs() {
            return {
                data: this.video,
                player: this.player,
            }
        },
        videoPlayerAttrs() {
            return {
                asset: this.video,
                hideControls: true,
                showCenterButtons: true,
                loop: true,
                clip: this.innerValue,
                options: this.playerOptions,
            }
        },
        playerOptions() {
            return {}
        },
    },
    watch: {
        trimData: {
            handler(val) {
                let calcVal = val
                if (_.isMatch(this.initValue, val)) {
                    calcVal = null
                }
                this.innerValue = calcVal
                this.$emit('input', calcVal)
            },
            deep: true
        },
    },
    created() {
        const duration = this.videoMeta?.duration || 0
        const end = this.duration = min(duration, floor(duration, 1), round(duration, 1))
        this.initValue = this.trimData = {start: 0, end}
    },
    methods: {
        playerReady() {
            this.player = this.$refs.player
        },
    }
}
</script>
